import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import * as firebase from 'firebase/app';
import 'firebase/storage'
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms/src/model';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Rx';
import { User } from '../datamodel/user';
import { UploadService } from '../../uploads/shared/upload.service';
import { Upload } from '../../uploads/shared/upload';
import { LocationService } from '../../services/locations/location.service';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as _ from 'underscore';
@Component({ selector: 'form-validation', templateUrl: './signup.component.html', styleUrls: ['./signup.component.scss'], providers: [WindowService] })
export class SignupComponent implements OnInit {
    title = 'SIGN UP';

    public lastError: string = null;
    public lastErrorPhone: string = null;

    public sentPhoneValidation: boolean = false;
    windowRef: any;

    private logoFileURL = "";
    public countries: any[];

    imgURL = "../../assets/img/no-image.png";

    constructor(public auth: AuthService, private win: WindowService, private upSvc: UploadService, private locationService: LocationService, private fb: FormBuilder, private spinnerService: Ng4LoadingSpinnerService) {

    }

    signupForm: FormGroup;

    selectedFiles: FileList;
    currentUpload: Upload;
    private basePath: string = '/uploads';
    uploads: Observable<Upload[]>;

    getCountries(): void {
        this.locationService.getCountries()
            .subscribe(x => {
                //console.log(x);
                this.countries = x;
            });
    }

    createSignupForm() {
        this.signupForm = this.fb.group({
            hospname: ['', Validators.required],
            country: ['231', Validators.required],
            state: ['', Validators.required],
            city: ['', Validators.required],
            address: ['', Validators.required],
            zipcode: [''],
            first_name: ['', Validators.required],
            last_name: ['', Validators.required],
            phone: ['', [
                Validators.minLength(10),
                Validators.maxLength(10),
                Validators.pattern("[0-9]*")
            ]],
            email: ['', [Validators.required, Validators.email]],
            password: ['', [
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(20)
            ]],
            confirm_password: ['', Validators.required]
        })
    }

    detectFiles(event) {
        this.selectedFiles = event.target.files;
        this.uploadLogo();
    }

    pushUploadLogo(upload: Upload) {
        let storageRef = firebase.storage().ref();
        let filename = Math.random().toString(36).split('').filter(function (value, index, self) {
            return self.indexOf(value) === index;
        }).join('').substr(2, 12);
        let uploadTask = storageRef.child(this.basePath + "/" + filename + upload.file.name).put(upload.file);
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
                // upload in progress
                upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100
            },
            (error) => {
                // upload failed
                console.log(error)
            },
            () => {
                // upload success
                upload.url = uploadTask.snapshot.downloadURL
                upload.name = upload.file.name
                this.upSvc.saveFileData(upload);
                this.logoFileURL = upload.url;
                this.imgURL = upload.url;
            }
        );
    }

    uploadLogo() {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        this.pushUploadLogo(this.currentUpload);
    }

    deleteLogo() {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        this.upSvc.deleteUpload(this.currentUpload);
        this.imgURL = "";
    }

    signup() {
        let self = this;
        this.lastError = null;
        self.spinnerService.show();
        console.log(this.logoFileURL);
        console.log(this.signupForm.value);
        this
            .auth
            .signup(this.signupForm.value, this.logoFileURL)
            .then(function (res) {
                console.log(res);
                self.spinnerService.hide();
            })
            .catch((error) => {
                console.log(error);
                self.spinnerService.hide();
                this.lastError = error.message;
            });
    }

    signupVerify() {
        /*this
            .windowRef
            .confirmationResult
            .confirm(this.email.nativeElement.value)
            .then(this.auth.verify)
            .catch(error => {
                console.log(error);
                this.lastErrorPhone = 'Incorrect verification code entered.'
            });*/
    }

    uploadImage() {

    }

    ngOnInit() {
        this.createSignupForm();
        this.getCountries();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/signup/signup.component.ts